// PH-15: stamp WHO rang a sale up — the name picked at login, or null when nobody named was logged
// in — onto the sale payload at checkout time. The stamp travels with an offline-queued sale, so a
// replay after someone else logs in on this device is still recorded under the person who made it
// (the server re-validates it against the roster and falls back to the session when it is not a
// current name for that login).
//
// A session saved before this change carries no `staff_id` key at all: then nothing is stamped and
// the server attributes the sale to the session, exactly as before. An explicit
// `sold_by_staff_id` already on the payload (an already-stamped queued sale) is never overwritten.
export function withSoldBy(data, storage = (typeof localStorage !== 'undefined' ? localStorage : null)) {
  if (!data || typeof data !== 'object' || Object.prototype.hasOwnProperty.call(data, 'sold_by_staff_id')) return data;
  try {
    const s = JSON.parse((storage && storage.getItem('session')) || '{}');
    if (!s || !Object.prototype.hasOwnProperty.call(s, 'staff_id')) return data;
    const id = Number.isInteger(s.staff_id) && s.staff_id > 0 ? s.staff_id : null;
    return { ...data, sold_by_staff_id: id };
  } catch {
    return data;
  }
}
